module.exports = __webpack_public_path__ + "media/images/undraw/reserve/meet_the_team-4b2d4a0a0dc6b471f89d244f76540682.png";